import { render } from "./PassengersComponent.vue?vue&type=template&id=33553c8a&ts=true"
import script from "./PassengersComponent.vue?vue&type=script&lang=ts"
export * from "./PassengersComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__